module.exports = __webpack_public_path__ + "static/media/gloves.1d2ab36d.png";